import { NEW_NOTIFICATION, READ_ALL_NOTIFICATIONS, READ_NOTIFICATION } from '../action.types'

export const addNewNotification = notification => {
  return {
    type: NEW_NOTIFICATION,
    notification
  }
}

export const readAll = () => {
  return {
    type: READ_ALL_NOTIFICATIONS
  }
}

export const readNotification = notification => {
  return {
    type: READ_NOTIFICATION,
    notification: { ...notification, read: true }
  }
}
